//import $ from 'jquery';

export default {
    init() {
        $('.sticky-share .sharing-icon').click(function() {
            $('.sticky-social-icons').slideToggle(300);
        });
    },
};
